import {
  getById,
  getRecommendedByFinanciamiento,
  getRecommendedByModel,
  getRecommendedByType,
} from "~/cars/api/server";
import { formatCarToView } from "~/cars/api/utils";
import { getMinimalYearForFinancimiento } from "~/common/utils/dates";
import CarScreen from "~/screens/Car/CarScreen";

const DEFAULT_FINANCIAMIENTO_NUMBER = "526624984562";

export async function getServerSideProps({ params }) {
  const { id } = params;

  // Obtener los datos del auto.
  const car = await getById({ id: Number(id) });
  console.log('-'.repeat(100))
  console.log(car)
  // const minFinancimientoYear = getMinimalYearForFinancimiento();
  const minFinancimientoYear = 2019;

  let metas = [
    {
      value: car.model.brand.brand,
      link: `/autos/?brand=${car.model.brand.brand}`,
      borderless: false,
      key: "brand",
    },
    {
      value: car.year,
      link: `/autos/?year=${car.year}`,
      borderless: false,
      key: "year",
    },
    {
      value: car.transmission.transmission,
      link: `/autos/?transmission=${car.transmission.transmission}`,
      borderless: false,
      key: "transmission",
    },

    {
      value: car.located.state.state,
      link: `/autos/?state=${car.located.state.state}`,
      borderless: false,
      key: "state",
    },
    {
      value: car.located.city,
      link: `/autos/?city=${car.located.city}`,
      borderless: false,
      key: "city",
    },
  ];
  // Store base metas. modelo, marca, transmission, año
  if (car.km) {
    metas.push({
      value: car.km,
      link: null,
      borderless: true,
      key: "km",
    });
  }

  const formatedCar = formatCarToView(car, metas);

  const slug = `${car.model.brand.brand}-${car.model.model}-${car.year}`;
  const recommendedByModel = await getRecommendedByModel({
    modelId: car.model.id,
    ignoreCar: car.id,
  });
  const recommendedByType = await getRecommendedByType({
    typeId: car.model.type.id,
    currentPrice: car.price,
    ignoreCar: car.id,
  });
  let recommendedFinanciados = []; // Only if the has year is currentyear - 10. carYear >= (currentYear - 10)[2012];
  if (car.year >= minFinancimientoYear) {
    recommendedFinanciados = await getRecommendedByFinanciamiento({
      ignoreCar: car.id,
      minYear: minFinancimientoYear,
    });
  }

  const financimientoNumber =
    (Boolean(car.business) && car.business?.financiamientoNumber) ||
    DEFAULT_FINANCIAMIENTO_NUMBER;

  return {
    props: {
      car: formatedCar,
      slug: slug.toLowerCase(),
      isFinanciable: car.year >= minFinancimientoYear && car.price !== 0,
      trackEntity: car.business
        ? car.business.trackEntity
        : car.particular.trackEntity,
      financiamientoContact: financimientoNumber,
      owner: {
        isBusiness: Boolean(car.business),
        business: Boolean(car.business) ? { id: car.business.id } : null,
        avatar:
          car.business?.avatar ||
          "https://seminuevossonora.com/images/icon_placeholder.png",
        name: car.business?.business || "Anonimo",
        schedule: car.business?.schedule || "",
        address: car.business?.address || "",
        slug: car.business?.slug || "",
        contactNumber: car.business?.phoneNumber || car.particular.phonenumber,
        whatsappPhoneNumber:
          car.business?.whatsappPhoneNumber || car.particular.phonenumber,
      },
      recommended: {
        byModel: recommendedByModel,
        byType: recommendedByType,
        byFinancimiento: recommendedFinanciados,
      },
    },
  };
}

export default function AutoPage(props) {
  return <CarScreen {...props} />;
}
